import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class TransactionApi{

    static findTransactions(type, params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTIONS}/${type}`;
        options.params = params;
        return request.get(options);
    }

    static getTransaction(tranId, tranType){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTIONS}/${tranType}/${tranId}`;
        options.params = {};
        return request.get(options);
    }
}

export default TransactionApi;


// WEBPACK FOOTER //
// ./src/api/TransactionsApi.js